import _ from "lodash";

export const addDepartment = (state, action) => {
  let list = state.list;
  const savedDepartment = action.payload;

  return [savedDepartment, ...list];
};

export const updateDepartment = (state, action) => {
  let list = state.list;
  const updatedDepartment = action.payload;

  const index = _.findIndex(list, ["id", updatedDepartment.id]);
  list[index] = updatedDepartment;

  return [...list];
};

export const removeDepartment = (state, action) => {
  let list = state.list;
  const deletedDepartment = action.payload;

  const filteredList = _.filter(list, function (td) {
    return td.id !== deletedDepartment.id;
  });

  return [...filteredList];
};
export const formtValidationErrors = (validationErrors) => {
  const keys = Object.keys(validationErrors);
  const errors = [];

  keys.forEach((key) => {
    errors.push({
      name: key,
      errors: validationErrors[key],
    });
  });

  return errors;
};
